export class FinancialProcessorRunnerViewModel {
	constructor(
		public Id: number,
		public Name: string,
		public RecordsAmount: number) { }
}